module.exports = __webpack_public_path__ + "static/media/tharu-tika-thumbnail.47320b14.png";